import axios from "axios";
import { BASE_URL } from "../../../constants";

// Settings
const apiConfig = {
  baseURL: BASE_URL,
};

// Client
const API = (access_token) => {
  var headers = {
    "Content-Type": "application/x-www-form-urlencoded",
  };

  const instance = axios.create({ baseURL: apiConfig.baseURL, headers: headers });

  instance.interceptors.response.use(
    function (response) {
      if (response.data.error) {
        return Promise.reject(response.data.error);
      } else {
        return response;
      }
    },
    function (error) {
      return Promise.reject({ code: error.response.status, message: error.response.statusText });
    }
  );

  return instance;
};

const Manager = {
  apiConfig: apiConfig,
  client: (access_token) => API(access_token),
};

export default Manager;
